import { Toolbar } from "../../components/ui/toolbar/toolbar.component";

export const StatisticsReadOnlyActions = () => {
  return <Toolbar actions={[]} />;
};
